import React, { Component } from 'react';
import './WorkPlaceClipboard.css';
import workplaceCopy from '../../../images/icons/workplaceCopy.png';
import { Tooltip } from 'devextreme-react/tooltip';
import SvgCopyIcon from '../../../iconComponents/iconCopy';
import SvgQrIcon from '../../../iconComponents/qrcode';

const animationConfig = {
    show: {
        type: 'slide',
        from: {
            top: -100,
            opacity: 0
        },
        to: {
            top: 0,
            opacity: 1
        }
    },
    hide: {
        type: 'pop',
        from: {
            scale: 1,
            opacity: 1
        },
        to: {
            scale: 0.1,
            opacity: 0
        }
    }
};




class WorkplaceClipboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultVisible: false,
            withAnimationVisible: false,
            withTemplateVisible: false
        };
        this.toggleDefault = this.toggleDefault.bind(this);
        this.toggleWithTemplate = this.toggleWithTemplate.bind(this);
        this.toggleWithAnimation = this.toggleWithAnimation.bind(this);

    }
    generateQR() {
        
        this.props.generateQRCode();
    }
    render() {

        return (

            <div style={{ float: 'inherit' }}>
                {/*<img
                    id="product3"
                    onMouseEnter={this.toggleWithAnimation}
                    onMouseLeave={this.toggleWithAnimation}
                    className='clipboard'
                  
                    src={workplaceCopy} />*/}
               
                <SvgCopyIcon /><span style={{ paddingLeft: '10px' }}>Copy Path</span>
                <Tooltip
                    target="#product3"
                    position="top"
                    //animation={animationConfig}
                    visible={this.state.withAnimationVisible}
                    closeOnOutsideClick={false}
                >
                    <div>Copy to Clipboard</div>
                </Tooltip>


                {/*<img style={{ height: '40px', width: '40px', zIndex: 10, color: "#fff", marginTop: '-27px', marginLeft: '77px', float: 'right' }} src={workplaceCopy} data-toggle="tooltip" data-placement="right" title="Copy to Clipboard" />*/}

            </div>

        );


    }
    toggleDefault() {
        this.setState({
            defaultVisible: !this.state.defaultVisible
        });
    }

    toggleWithTemplate() {
        this.setState({
            withTemplateVisible: !this.state.withTemplateVisible
        });
    }

    toggleWithAnimation() {
        this.setState({
            withAnimationVisible: !this.state.withAnimationVisible
        });
    }
}
export default WorkplaceClipboard;




// WEBPACK FOOTER //
// ./src/components/TaskView/WorkPlace/WorkplaceClipboard.js